var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.843 -0.000488281C2.60623 -0.000488281 0 2.60575 0 5.84251V26.1565C0 29.3932 2.60623 31.9995 5.843 31.9995H16.853V19.4895H13.545V14.9855H16.853V11.1375C16.853 8.11431 18.8075 5.33851 23.31 5.33851C25.1329 5.33851 26.481 5.51352 26.481 5.51352L26.375 9.71952C26.375 9.71952 25.0001 9.70653 23.5 9.70653C21.8763 9.70653 21.616 10.4546 21.616 11.6965V14.9855H26.5039L26.291 19.4895H21.616V31.9995H26.1569C29.3937 31.9995 31.9999 29.3933 31.9999 26.1565V5.84254C31.9999 2.60578 29.3937 -0.000456281 26.1569 -0.000456281H5.84296L5.843 -0.000488281Z",
    fill: "#F68D10"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.2d6f2ac892afb4fcc168715b47d0ecfd.svg";
export { ForwardRef as ReactComponent };